import { Link } from "react-router-dom"

import Button from "components/ui/button"

const Footer = () => {
  return (
    <footer className="tablet:pt-40 tablet:px-32 bg-grey-4 tablet:flex-row mt-auto flex flex-col-reverse items-center justify-between px-10 pb-16 pt-28 text-center">
      <span className="text-12">Powered by SAFYRE LABS, INC.</span>
      <ul className="text-grey-65 tablet:m-0 mb-10 flex list-none items-center">
        <li>
          <Button asChild className="text-14" text underline>
            <Link to="/terms-conditions">Terms of Platform</Link>
          </Button>
        </li>
        <li aria-hidden="true">
          <div className="bg-grey-65 mx-8 inline-block h-14 w-px" />
        </li>
        <li>
          <Button asChild className="text-14" text underline>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </Button>
        </li>
      </ul>
    </footer>
  )
}
export default Footer
